
import { WebhookResponse } from "@/types/chat";

// Webhook URL per il servizio chat
const CHAT_WEBHOOK_URL = "https://hook.eu1.make.com/ioreaorx4dgljrbvuud1vu14ciqp718f";
const REQUEST_TIMEOUT_MS = 120000; // Aumentato a 120 secondi per dare più tempo al webhook

export interface ChatContextData {
  goldPrice: number | null;
  goldChange: number | null;
  goldPriceDate: string | null;
  silverPrice: number | null;
  silverChange: number | null;
  silverPriceDate: string | null;
  dealersCount: number;
  topDealers: string[];
  message: string;
  timestamp: string;
  userLocation: {
    latitude: number;
    longitude: number;
  } | null;
  userCity: string | null;
  userName: string | null;
  userEmail: string | null;
  userId: string | null;
  isAnonymous: boolean;
}

export async function sendChatRequest(contextData: ChatContextData): Promise<WebhookResponse | null> {
  // Implementiamo un timeout per la richiesta
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);
  
  try {
    console.log("Sending chat request:", contextData);
    
    // Prepariamo i dati per il formato richiesto dal webhook
    const requestData = {
      goldPrice: contextData.goldPrice,
      goldChange: contextData.goldChange,
      goldPriceDate: contextData.goldPriceDate,
      silverPrice: contextData.silverPrice,
      silverChange: contextData.silverChange,
      silverPriceDate: contextData.silverPriceDate,
      dealersCount: contextData.dealersCount,
      topDealers: contextData.topDealers,
      message: contextData.message,
      timestamp: contextData.timestamp,
      userLocation: contextData.userLocation,
      userCity: contextData.userCity,
      userName: contextData.userName,
      userEmail: contextData.userEmail,
      userId: contextData.userId,
      isAnonymous: contextData.isAnonymous
    };
    
    const response = await fetch(CHAT_WEBHOOK_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
      signal: controller.signal
    });
    
    clearTimeout(timeoutId);
    
    if (!response.ok) {
      console.warn(`Chat webhook HTTP error! status: ${response.status}`);
      return { text: "Mi dispiace, al momento non riesco a rispondere. Riprova tra poco." };
    }
    
    // Verifichiamo che la risposta sia in formato JSON o text
    const contentType = response.headers.get("content-type");
    
    try {
      let responseData;
      
      if (contentType && contentType.includes("application/json")) {
        responseData = await response.json();
      } else {
        const textResponse = await response.text();
        return { text: textResponse };
      }
      
      // Adattiamo la risposta al formato WebhookResponse
      if (responseData.Body) {
        return { text: responseData.Body };
      } else if (responseData.text) {
        return responseData;
      } else if (responseData.message) {
        return { text: responseData.message };
      } else {
        return { text: JSON.stringify(responseData) };
      }
    } catch (error) {
      console.warn("Errore nel parsing della risposta del webhook:", error);
      return { text: "Mi dispiace, al momento non riesco a rispondere. Riprova tra poco." };
    }
  } catch (error) {
    console.error("Errore chiamata webhook:", error);
    clearTimeout(timeoutId);
    return { text: "Mi dispiace, al momento non riesco a rispondere. Riprova tra poco." };
  }
}
